import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import dynamic from 'next/dynamic';
import { useSiteSpect } from '../../utils/context/sitespect-provider';

const NavigationMenuTest = dynamic(() => import('../../tissues/navigation-new'));
const NavigationHeaderSearch = dynamic(() => import('../../tissues/navigation-header/search'));
const NavigationHeaderAlgolia = dynamic(() => import('../../tissues/navigation-header'));
const CheckoutHeader = dynamic(() => import('../../molecules/checkout-header'));
const NavigationMenu = dynamic(() => import('../../tissues/navigation'));
const MobileNavigationMenu = dynamic(() => import('../../tissues/mobile-navigation'));
const PetiteDropDown = dynamic(() => import('../../tissues/petite-dropdown'));
const PromotionBanner = dynamic(() => import('../../tissues/promotion-copy'));

const Vestibule = (props) => {
  const { navigation = false, algolia = false } = useSiteSpect();

  return (
    <>
      {
        props.isCheckout
          ? (
            <>
              <PromotionBanner content={props.promotionContent} />
              <CheckoutHeader />
            </>
          )
          : (
            <>
              <PromotionBanner content={props.promotionContent} />
              {
                algolia
                  ? <NavigationHeaderAlgolia />
                  : <NavigationHeaderSearch />
              }
            </>
          )
      }

      { props.user?.spree_api_key && <PetiteDropDown /> }

      {
        !props.noNav && (
          <>
            {
            !navigation ? (
              <NavigationMenu
                navigation={props.navigation}
                isCheckout={props.isCheckout}
              />
            ) : <NavigationMenuTest navigation={props.navigationVariation} />
          }

            {
            props.mobileNavigation !== null && (
              <MobileNavigationMenu
                navigation={props.mobileNavigation}
                profile={props.profile}
                isCheckout={props.isCheckout}
              />
            )
          }
          </>
        )
      }
    </>
  );
};

Vestibule.defaultProps = {
  promotionContent: [],
  user: {},
  profile: {},
  isCheckout: false,
  noNav: false
};

Vestibule.propTypes = {
  navigation: PropTypes.object.isRequired,
  navigationVariation: PropTypes.object.isRequired,
  mobileNavigation: PropTypes.array.isRequired,
  promotionContent: PropTypes.array,
  user: PropTypes.object,
  profile: PropTypes.object,
  isCheckout: PropTypes.bool,
  noNav: PropTypes.bool
};

const mapStateToProps = (state) => ({
  user: state.user,
  profile: state.profile
});

const ConnectedVestibule = connect(mapStateToProps, null)(Vestibule);

Vestibule.whyDidYouRender = true;

export default ConnectedVestibule;
